import React, { useState } from 'react';
import './VideoHistory.css';

interface VideoHistoryProps {
  onVideoSelect: (videoUrl: string) => void;
}

interface HistoryItem {
  id: string;
  title: string;
  thumbnail: string;
  videoUrl: string;
  createdAt: string;
  duration: string;
  resolution: string;
  model: string;
}

const VideoHistory: React.FC<VideoHistoryProps> = ({ onVideoSelect }) => {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

  // 模拟历史记录数据
  const historyItems: HistoryItem[] = [
    {
      id: '1',
      title: 'Mountain Sunset',
      thumbnail: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=400&fit=crop',
      videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4',
      createdAt: '2 hours ago',
      duration: '5s',
      resolution: '720p',
      model: 'Wan 2.5'
    },
    {
      id: '2',
      title: 'Forest Landscape',
      thumbnail: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&h=400&fit=crop',
      videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_2mb.mp4',
      createdAt: '1 day ago',
      duration: '10s',
      resolution: '1080p',
      model: 'Wan 2.0'
    },
    {
      id: '3',
      title: 'Ocean Waves',
      thumbnail: 'https://images.unsplash.com/photo-1505142468610-359e7d316be0?w=400&h=400&fit=crop',
      videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_3mb.mp4',
      createdAt: '3 days ago',
      duration: '3s',
      resolution: '720p',
      model: 'Wan 2.5'
    },
    {
      id: '4',
      title: 'City Skyline',
      thumbnail: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=400&fit=crop',
      videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_4mb.mp4',
      createdAt: '1 week ago',
      duration: '8s',
      resolution: '4K',
      model: 'Wan 1.5'
    },
    {
      id: '5',
      title: 'Desert Dunes',
      thumbnail: 'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=400&h=400&fit=crop',
      videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_2mb.mp4',
      createdAt: '2 weeks ago',
      duration: '7s',
      resolution: '1080p',
      model: 'Wan 2.0'
    },
    {
      id: '6',
      title: 'Northern Lights',
      thumbnail: 'https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?w=400&h=400&fit=crop',
      videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_3mb.mp4',
      createdAt: '3 weeks ago',
      duration: '6s',
      resolution: '720p',
      model: 'Wan 1.5'
    },
    {
      id: '7',
      title: 'Tropical Beach',
      thumbnail: 'https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?w=400&h=400&fit=crop',
      videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4',
      createdAt: '1 month ago',
      duration: '5s',
      resolution: '1080p',
      model: 'Wan 2.5'
    },
    {
      id: '8',
      title: 'Snowy Mountains',
      thumbnail: 'https://images.unsplash.com/photo-1519904981063-b0cf448d479e?w=400&h=400&fit=crop',
      videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_2mb.mp4',
      createdAt: '1 month ago',
      duration: '4s',
      resolution: '720p',
      model: 'Wan 2.0'
    },
    {
      id: '9',
      title: 'Urban Street',
      thumbnail: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=400&h=400&fit=crop',
      videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_3mb.mp4',
      createdAt: '2 months ago',
      duration: '9s',
      resolution: '4K',
      model: 'Wan 1.5'
    },
    {
      id: '10',
      title: 'Waterfall Cascade',
      thumbnail: 'https://images.unsplash.com/photo-1432405972618-c60b0225b8f9?w=400&h=400&fit=crop',
      videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4',
      createdAt: '2 months ago',
      duration: '6s',
      resolution: '1080p',
      model: 'Wan 2.5'
    }
  ];

  const handleVideoClick = (item: HistoryItem) => {
    setSelectedVideo(item.id);
    onVideoSelect(item.videoUrl);
  };

  return (
    <div className="video-history">
      <div className="history-header">
        <h3>History</h3>
      </div>

      <div className="history-content">
        {historyItems.length === 0 ? (
          <div className="empty-history">
            <div className="empty-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23 7L16 12L23 17V7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <rect x="1" y="5" width="15" height="14" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <p>No videos generated yet</p>
            <span>Your video history will appear here</span>
          </div>
        ) : (
          <div className="history-list">
            {historyItems.map((item) => (
              <div
                key={item.id}
                className={`history-item ${selectedVideo === item.id ? 'selected' : ''}`}
                onClick={() => handleVideoClick(item)}
              >
                <div className="item-thumbnail">
                  <img src={item.thumbnail} alt={item.title} />
                  <div className="play-overlay">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoHistory;

